import { render, staticRenderFns } from "./TabViewsView.vue?vue&type=template&id=2b119806&scoped=true&lang=pug"
import script from "./TabViewsView.vue?vue&type=script&lang=js"
export * from "./TabViewsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b119806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b119806')) {
      api.createRecord('2b119806', component.options)
    } else {
      api.reload('2b119806', component.options)
    }
    module.hot.accept("./TabViewsView.vue?vue&type=template&id=2b119806&scoped=true&lang=pug", function () {
      api.rerender('2b119806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/workbook/TabViewsView.vue"
export default component.exports